<template>
  <div class="buttonListChangeTwoToThree">
    <div class="nav-box" :class="btnVal == '2D' ? 'active-nav-item':'active-nav-item3d'">
      <div class="nav-item"
           @click="navChange()">
        <div class="nav-text">
          3D
        </div>
      </div>
      <div class="nav-item-last"
           @click="navChange2D()">
        <div class="nav-text">
          2D
        </div>
      </div>

      <div class="nav-item nav-item-three" @click="changeThree3D">
        <div class="nav-text">
          3D
        </div>
      </div>
      <div class="nav-item-last nav-item-last-three" @click="changeThree2D">
        <div class="nav-text">
          2D
        </div>
      </div>

      <div class="nav-item-back" @click="navChangeBack()">
        <div>
          返回
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/utils/eventBus";
export default {
  watch: {},
  props: ["btnVal"],
  data() {
    return {
    };
  },
  created() {
    // this.active = "3D";
  },
  methods: {
    navChange2D() {
      this.active = "2D";
      this.$emit("btnChange", this.active);
    },
    navChange() {
      this.active = "3D";
      this.$emit("btnChange", this.active);
    },
    navChangeBack() {
      this.active = "back";
      this.$emit("btnChange", this.active);
      EventBus.$emit("callSomeMethod");
    },
    changeThree3D() {
      this.btnVal = "3D";
      const moduleUIBtns = document.getElementsByClassName("module-ul");

      for (let moduleUIBtn of moduleUIBtns) {
        moduleUIBtn.style.display = "flex";
      }

      const buttonListBoxBtns = document.getElementsByClassName("buttonList-box");

      for (let buttonListBoxBtn of buttonListBoxBtns) {
        buttonListBoxBtn.style.zIndex = "8";
        buttonListBoxBtn.style.left = "1212px";
        buttonListBoxBtn.style.bottom = "180px";
      }
      EventBus.$emit("changeTwoDMToThreeD");
    },
    changeThree2D() {
      this.btnVal = "2D";
      const navItemThreeBtns = document.getElementsByClassName("big-two-map-box");

      for (let navItemThreeBtn of navItemThreeBtns) {
        navItemThreeBtn.style.zIndex = "12";
        navItemThreeBtn.style.width = "80%";
        navItemThreeBtn.style.height = "80%";
        navItemThreeBtn.style.left = "10%";
        navItemThreeBtn.style.top = "10%";
      }
      const containerBtns = document.getElementsByClassName("container-map-box");

      for (let containerBtn of containerBtns) {
        containerBtn.style.zIndex = "11";
        containerBtn.style.width = "100vw";
        containerBtn.style.height = "100vh";
        containerBtn.style.backgroundColor = "#080814";
      }

      const moduleUIBtns = document.getElementsByClassName("module-ul");

      for (let moduleUIBtn of moduleUIBtns) {
        moduleUIBtn.style.display = "none";
      }

      const buttonListBoxBtns = document.getElementsByClassName("buttonList-box");

      for (let buttonListBoxBtn of buttonListBoxBtns) {
        buttonListBoxBtn.style.zIndex = "12";
        buttonListBoxBtn.style.left = "1512px";
        buttonListBoxBtn.style.bottom = "100px";
      }
      this.$nextTick(() => {
        EventBus.$emit("changeThreeDToTwoD");
      });
    }
  }
};
</script>

<style scoped lang="less">
.active-nav-item3d{
  background: url("../assets/3d.png") no-repeat;
  background-size: 100%;
}
.active-nav-item {
  background:url("../assets/2d.png") no-repeat;
  background-size: 100%;
}

.buttonListChangeTwoToThree {
  display: flex;
  font-family: AlibabaRegular;
  position: absolute;
  left: 540px;
  top: 230px;
  width: 160px;
  height: 60px;
  background-size: 100%;
    z-index: 8;
  .nav-box {
    width: 150px;
    height: 58px;
    position: absolute;
    display: flex;
    border-radius: 7px;
    .nav-item {
      cursor: pointer;
      border-radius: 7px 0 7px 7px;
      width: 83px;
      height: 58px;
      line-height: 58px;
      position: absolute;
      box-sizing: border-box;
      clip-path: polygon(
        0% 0%,            /* 矩形左上角 */
        0 0%, /* 矩形右上中间 */
        100% 0%,          /* 矩形右上角 */
        80% 100%,        /* 矩形右下角 */
        0 100%, /* 矩形右下中间 */
        0% 100%,          /* 矩形左下角 */
        0% 0%, /* 矩形左下角被切掉的部分*/
        0	0%
      );
    }
    .nav-text {
      font-size: 28px;
      font-weight: 700;
      color: #FFF;
    }

    .nav-item-three {
      display: none;
      user-select: none;
    }
    .nav-item-last-three {
      display: none;
      user-select: none;
    }

    .nav-item-last {
      cursor: pointer;
      position: absolute;
      left: 45%;
      border-radius: 0 7px 7px 0;
      width: 83px;
      height: 58px;
      line-height: 58px;
      background-size: 100%;
      box-sizing: border-box;
      clip-path: polygon(
          20% 0%,            /* 矩形左上角 */
          70% 0 , /* 矩形右上中间 */
          100% 0%,          /* 矩形右上角 */
          100% 100%,        /* 矩形右下角 */
          0 100%, /* 矩形右下中间 */
          0% 100%,          /* 矩形左下角 */
          0% 100%, /* 矩形左下角被切掉的部分*/
          0	100%
      );
    }
    .nav-item-back {
      user-select: none;
      cursor: pointer;
      position: absolute;
      left: 100%;
      top: 5px;
      border-radius: 7px;
      width: 98px;
      height: 51px;
      line-height: 51px;
      background: linear-gradient(to right, #5f628c, #22232e);
      font-size: 24px;
      font-weight: 700;
      color: #FFF;
      display: none;
      //background-size: 100%;
      //box-sizing: border-box;
      //clip-path: polygon(
      //    20% 0%,            /* 矩形左上角 */
      //    70% 0 , /* 矩形右上中间 */
      //    100% 0%,          /* 矩形右上角 */
      //    100% 100%,        /* 矩形右下角 */
      //    0 100%, /* 矩形右下中间 */
      //    0% 100%,          /* 矩形左下角 */
      //    0% 100%, /* 矩形左下角被切掉的部分*/
      //    0	100%
      //);
    }
  }
}
</style>
